import { DEFAULT_SITE } from './siteDefaults';

function strPrefer(a, b, fallback) {
  if (typeof a === 'string' && a.trim()) return a.trim();
  if (typeof b === 'string' && b.trim()) return b.trim();
  return typeof fallback === 'string' ? fallback : '';
}

const FALLBACK_SECTION_LABEL = "Founder's desk";
const FALLBACK_NAME = 'Mostak Ahammad';
const FALLBACK_ROLE = 'Founder & Managing Director, Rafid Seeds Company';
const FALLBACK_MESSAGE_1 =
  'Rafid Seeds Company is committed to empowering Bangladeshi farmers through high-quality, high-yielding, and climate-resilient seeds. We develop improved hybrid and non-hybrid varieties of rice, maize, and vegetables to support sustainable agriculture and national food security.';
const FALLBACK_MESSAGE_2 =
  'With a strong focus on research, innovation, and farmer support, we work to bridge modern agricultural science with real field needs. Our growing network across Bangladesh ensures that quality seeds reach farmers nationwide, contributing to rural development and agricultural prosperity.';
const FALLBACK_MESSAGE_3 =
  'We remain dedicated to continuous improvement, inclusive growth, and long-term partnerships for a more self-reliant farming future.';
const FALLBACK_CTA_LABEL = 'Speak with us';
const FALLBACK_CTA_HREF = '#contact';
const FALLBACK_PORTRAIT_URL =
  'https://res.cloudinary.com/dnw8qhp3h/image/upload/v1776507380/Gemini_Generated_Image_r91nqgr91nqgr91n_yywhoq.png';
const FALLBACK_PORTRAIT_ALT =
  'Mostak Ahammad, Founder and Managing Director, Rafid Seeds Company';

/** Founder desk section copy and media from API / bundled defaults. */
export function resolveFounderDesk(site) {
  const d =
    DEFAULT_SITE.founderDesk && typeof DEFAULT_SITE.founderDesk === 'object'
      ? DEFAULT_SITE.founderDesk
      : {};
  const x = site?.founderDesk && typeof site.founderDesk === 'object' ? site.founderDesk : {};

  return {
    sectionLabel: strPrefer(x.sectionLabel, d.sectionLabel, FALLBACK_SECTION_LABEL),
    name: strPrefer(x.name, d.name, FALLBACK_NAME),
    role: strPrefer(x.role, d.role, FALLBACK_ROLE),
    message1: strPrefer(x.message1, d.message1, FALLBACK_MESSAGE_1),
    message2: strPrefer(x.message2, d.message2, FALLBACK_MESSAGE_2),
    message3: strPrefer(x.message3, d.message3, FALLBACK_MESSAGE_3),
    ctaLabel: strPrefer(x.ctaLabel, d.ctaLabel, FALLBACK_CTA_LABEL),
    ctaHref: strPrefer(x.ctaHref, d.ctaHref, FALLBACK_CTA_HREF),
    portraitUrl: strPrefer(x.portraitUrl, d.portraitUrl, FALLBACK_PORTRAIT_URL),
    portraitAlt: strPrefer(x.portraitAlt, d.portraitAlt, FALLBACK_PORTRAIT_ALT),
  };
}
